/* eslint-disable @typescript-eslint/no-unused-vars */
import capitalize from 'lodash/capitalize';

import { VariantNode, VariantRuleStylesheet } from '@candu-ai/styleguide/types';

import { ComponentFilteredSession, ComponentUnfilteredSession } from './types';

const doesSearchMatch = (search: string | undefined, label: string) => {
  if (!search) {
    return true;
  }
  return search && label.toLowerCase().indexOf(search) > -1;
};

export const filterComponentsAgainstVariants = (
  search: string | undefined,
  styleguideVariants: VariantRuleStylesheet | undefined,
  components: ComponentUnfilteredSession[],
): ComponentFilteredSession[] => {
  return components
    .map((section) => {
      const isSectionMatchingSearch = doesSearchMatch(search, section.label);
      // first, let's see if it has matching non styleguide component
      const builtIn = (section.builtIn || []).filter(
        ({ label }) => isSectionMatchingSearch || doesSearchMatch(search, label),
      );
      const variantList = Object.entries(
        styleguideVariants?.[capitalize(section.styleguide?.section || '')] || {},
      );
      const isTypography = section.styleguide?.section === 'typography';
      const variants = (variantList
        ?.filter(
          ([_, variant]) =>
            !variant.isHidden && (isSectionMatchingSearch || doesSearchMatch(search, variant.name)),
        )
        .map(([key, v]) => ({
          name: v.name,
          conditions:
            v.tagName || isTypography
              ? { variant: v.tagName?.toUpperCase() || 'P', variation: key }
              : { variant: key },
        })) || []) as VariantNode[];

      return {
        ...section,
        builtIn,
        variants,
      };
    })
    .filter((section) => section.variants.length + section.builtIn.length > 0);
};
